import { ActionButtonVariants } from 'components/action-button';

export const config = {
  buttonVariant: ActionButtonVariants.OUTLINE,
  hasStartIcon: false,
  showNumItems: false,
  isSquare: true,
};
